// Notifications state

// Configuration values
const configuration = {
  notificationTimeout: 5000 // Notification timeout (in milliseconds);
};

// Initial state
const state = () => ({
  notifications: [] // notifications are objects with { type, title, description, id } keys
});

// Getters
const getters = {
  notifications: (state, getters, rootState) => {
    return state.notifications;
  }
};

// Actions
const actions = {
  // Adds a notification, and then removes it once its timeout has been reached
  add({ commit, state }, { type, title, description }) {
    const id = new Date().getTime() + Math.ceil(Math.random() * 100000000000); // Use current timestamp as notification ID
    commit("add", { type, title, description, id });
    setTimeout(() => {
      commit("remove", id);
    }, configuration.notificationTimeout);
  },

  // Removes a notification
  remove({ commit, state }, notificationId) {
    commit("remove", notificationId);
  },

  // Change Basket indication
  changeBasketIndication({ commit, state }) {
    commit("changeBasketIndication");
  }
};

// Mutations
const mutations = {
  add(state, { type, title, description, id }) {
    state.notifications.push({ type, title, description, id });
  },
  remove(state, id) {
    state.notifications = state.notifications.filter(n => n.id !== id);
  },
  changeBasketIndication(state) {
    let basketIcon = document.querySelector(
      "#header .nav-top-secondary-desktop .png-icon.png-icon-icons-glyph--ko-my-basket"
    );
    if (
      !basketIcon ||
      basketIcon.classList.contains("nav-top-customer-link-with-indicator")
    )
      return;

    basketIcon.classList.add("nav-top-customer-link-with-indicator");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
